import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import resource from "./resource.module.css";
import { FaArrowRightLong } from "react-icons/fa6";
import {
  getAllresources,
  getAllResourceCategories,
  getResourceByCategoryId,
} from "../../../Services/APIrequests";
import defaultIMG from "../../../Assets/defaultimg.png";
import parse from "html-react-parser";

const ResourceBoxs = () => {
  const [resources, setResources] = useState([]);
  const [filteredResources, setFilteredResources] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const navigate = useNavigate();

  const handleClick = (resourceId) => {
    navigate(`/resources/${resourceId}`);
  };

  useEffect(() => {
    // Fetch resources
    const fetchResources = async () => {
      try {
        const response = await getAllresources();
        setResources(response.data?.resources || []);
        setFilteredResources(response.data?.resources || []);
      } catch (error) {
        console.error("Error fetching resources:", error);
      }
    };

    // Fetch categories
    const fetchCategories = async () => {
      try {
        const response = await getAllResourceCategories();
        if (Array.isArray(response.data.categories)) {
          setCategories(response.data.categories);
        } else {
          console.error("Categories data is not an array:", response.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchResources();
    fetchCategories();
  }, []);

  const handleCategoryChange = async (e) => {
    const selectedCategoryId = e.target.value;
    setSelectedCategoryId(selectedCategoryId);

    if (selectedCategoryId === "") {
      setFilteredResources(resources);
    } else {
      try {
        const response = await getResourceByCategoryId(selectedCategoryId);
        const resourcesData = Array.isArray(response.data.resources)
          ? response.data.resources
          : [];

        setFilteredResources(resourcesData);
      } catch (error) {
        console.error("Error fetching resources by category:", error);
        setFilteredResources([]);
      }
    }
  };

  return (
    <div className={resource.Resourceboxces_container}>
      {/* Dropdown for categories */}
      <div className={resource.Resourceboxces_categories}>
        <label htmlFor="categoryDropdown" className={resource.filterLabel}>
          Filter by Resource Category:
        </label>
        <div className={resource.dropdownWrapper}>
          <select
            id="categoryDropdown"
            value={selectedCategoryId}
            className={resource.categoryDropdown}
            onChange={handleCategoryChange}
          >
            <option value="">All Categories</option>
            {categories.map((category) => (
              <option key={category.categoryId} value={category.categoryId}>
                {category.categoryName}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Resources display */}
      <div className={resource.subcontainer}>
        {Array.isArray(filteredResources) && filteredResources.length > 0 ? (
          filteredResources.map((resourceItem) => (
            <div
              key={resourceItem.resourceId}
              className={resource.resourceBox}
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
              onClick={() => handleClick(resourceItem.resourceId)}
            >
              <div className={resource.imagecontainer}>
                <img
                  src={resourceItem.thumbnail || defaultIMG}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = defaultIMG;
                  }}
                  alt="resource image"
                  className={resource.rbox_img}
                />
              </div>
              <h1 className={resource.boxheader}>{resourceItem.title}</h1>
              <p className={resource.boxptext}>
                {resourceItem.shortDescription
                  ? parse(resourceItem.shortDescription)
                  : ""}
              </p>

              <button
                type="button"
                className={resource.btn}
                onClick={() => handleClick(resourceItem.resourceId)}
              >
                View All <FaArrowRightLong />
              </button>
            </div>
          ))
        ) : (
          <p>No resources available for this category.</p>
        )}
      </div>
    </div>
  );
};

export default ResourceBoxs;
